export default __webpack_public_path__ + "static/Higher-Leads-and-Conversation-Rates-028071403e5450a1acaddca3061a0d16.webp";